import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"
import * as axios from 'axios';

export default {
    obterEquipamentosAsync,
    obterEquipamentoAsync,
    enviarEquipamentoAsync,
    editarEquipamentoAsync,
    obterBase64NFCompraAsync,
    downloadNFCompra,
    downloadNFVenda,
    downloadLista
}

export const obterEquipamentosAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Equipamento/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}
export const obterEquipamentoAsync = async (idEquipamento) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Equipamento/obter/` + idEquipamento, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => result.data);
}
export const obterEquipamentosSelecaoAsync = async (incluirInativos = false) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    const query = new URLSearchParams({
        incluirInativos: String(incluirInativos)
    });

    return fetch(`${process.env.VUE_APP_API_URL}/Equipamento/obterListaSelecao?${query}`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => result.data);
}
export const obterEquipamentosPorPlanoAsync = async (idPlano) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Equipamento/obterListaPorPlano/` + idPlano, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

/*export const enviarEquipamentoAsync = async(tipo, idFamilia, chassi, placa, prefixo, idGrupo, idMarca, idModelo, idProprietario, centroCusto, seguradora, valorCompra, valorVenda, dataVenda, dataCompra, nfVenda, nfCompra, anexoNfCompra, anexoNfVenda, implementos, acessorios, informacoesTecnicas) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ tipo, idFamilia, chassi, placa, prefixo, idGrupo, idMarca, idModelo, idProprietario, centroCusto, seguradora, valorCompra, valorVenda, dataVenda, dataCompra, nfVenda, nfCompra, anexoNfCompra, anexoNfVenda, implementos, acessorios, informacoesTecnicas })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Equipamento`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}*/

export const enviarEquipamentoAsync = (imagem, tipo, idFamilia, idUnidadeAdm, chassi, placa, prefixo, ano, apelido, idGrupo, idMarca, idModelo, idProprietario, centroCusto, seguradora, valorCompra, valorVenda, dataVenda, dataCompra, nfVenda, nfCompra, nfAnexoCompra, nfAnexoVenda, anexoNfCompra, anexoNfVenda, implementos, acessorios, informacoesTecnicas, anexos, ativo) => {

    const url = `${process.env.VUE_APP_API_URL}/Equipamento`;
    const requestOptions = {
        headers: { 'Authorization': 'bearer ' + obterToken() },
    };
    let formData = new FormData();

    /*for (var i = 0; i < nfAnexoCompra.length; i++) {
        let file = nfAnexoCompra[i];

        formData.append('fileNfCompra[' + i + ']', file);
    }*/

    /*if (anexos != null) {
        for (var i = 0; i < anexos.length; i++) {
            if (anexos[i].file != null) {
                let fileAnexo = anexos[i].file;

                formData.append('filesAnexo[' + i + ']', fileAnexo);
            }
        }
    }
    if (anexos != null) {
        var filesAnexo = [];
        for (var i = 0; i < anexos.length; i++) {
            if (anexos[i].file != null) {
                filesAnexo.push(anexos[i].file);

            }
        }
        formData.append('filesAnexo', filesAnexo);
    }*/

    if (anexos != null) {
        Array.from(Array(anexos.length).keys()).map((x) => {
            if (anexos[x].file != null) {
                formData.append('filesAnexo', anexos[x].file);
            }
        });
    }
    formData.append('imagem', imagem);
    formData.append('fileNfCompra', nfAnexoCompra);
    formData.append('fileNfVenda', nfAnexoVenda);
    formData.append('equipamentoDataModel', JSON.stringify({ tipo, idFamilia, idUnidadeAdm, chassi, placa, prefixo, ano, apelido, idGrupo, idMarca, idModelo, idProprietario, centroCusto, seguradora, valorCompra, valorVenda, dataVenda, dataCompra, nfVenda, nfCompra, anexoNfCompra, anexoNfVenda, implementos, acessorios, informacoesTecnicas, anexos, ativo }));
    return axios.post(url, formData, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}
export const editarEquipamentoAsync = async (id, imagem, tipo, idFamilia, idUnidadeAdm, chassi, placa, prefixo, ano, apelido, idGrupo, idMarca, idModelo, idProprietario, centroCusto, seguradora, valorCompra, valorVenda, dataVenda, dataCompra, nfVenda, nfCompra, nfAnexoCompra, nfAnexoVenda, anexoNfCompra, anexoNfVenda, implementos, acessorios, informacoesTecnicas, anexos, ativo) => {

    const url = `${process.env.VUE_APP_API_URL}/Equipamento/atualizar`;
    const requestOptions = {
        headers: { 'Authorization': 'bearer ' + obterToken() },
    };
    let formData = new FormData();
    
    const anexosFiles = anexos
        .map(a => a?.file)
        .filter(f => f instanceof File || f instanceof Blob);
    anexosFiles.forEach(f => formData.append('FilesAnexo', f, f.name));

    formData.append('imagem', imagem);
    formData.append('fileNfCompra', nfAnexoCompra);
    formData.append('fileNfVenda', nfAnexoVenda);
    formData.append('equipamentoDataModel', JSON.stringify({ id, tipo, idFamilia, idUnidadeAdm, chassi, placa, prefixo, ano, apelido, idGrupo, idMarca, idModelo, idProprietario, centroCusto, seguradora, valorCompra, valorVenda, dataVenda, dataCompra, nfVenda, nfCompra, anexoNfCompra, anexoNfVenda, implementos, acessorios, informacoesTecnicas, anexos, ativo }));

    return axios.post(url, formData, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}


export const obterBase64NFCompraAsync = async (idEquipamento) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Equipamento/obterBase64NFCompra/` + idEquipamento, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const obterBase64NFVendaAsync = async (idEquipamento) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Equipamento/obterBase64NFVenda/` + idEquipamento, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}
export function downloadNFCompra(idEquipamento, extensao, nomeArquivo) {
    try {
        return axios({
            url: `${process.env.VUE_APP_ROOT_API}/Equipamento/obterNFCompra/` + idEquipamento,
            method: 'GET',
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        }).catch(() => {
            return { status: false };
        })
            .then((response) => {
                if (response.status === false)
                    return response;
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', nomeArquivo);
                document.body.appendChild(fileLink);

                fileLink.click();
            });
    } catch (e) {
        throw e;
    }
}
export function downloadNFVenda(idEquipamento, extensao, nomeArquivo) {
    try {
        return axios({
            url: `${process.env.VUE_APP_ROOT_API}/Equipamento/obterNFVenda/` + idEquipamento,
            method: 'GET',
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        }).catch(() => {
            return { status: false };
        })
            .then((response) => {
                if (response.status === false)
                    return response;
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', nomeArquivo);
                document.body.appendChild(fileLink);

                fileLink.click();
            });
    } catch (e) {
        throw e;
    }
}
export function downloadAnexo(idEquipamento, idArquivo, nomeArquivo) {
    try {
        return axios({
            url: `${process.env.VUE_APP_ROOT_API}/Equipamento/obterAnexo/` + idEquipamento + `/` + idArquivo,
            method: 'GET',
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        }).catch(() => {
            return { status: false };
        })
            .then((response) => {
                if (response.status === false){
                    return response;
                }
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', nomeArquivo);
                document.body.appendChild(fileLink);

                fileLink.click();
            });
    } catch (e) {
        throw e;
    }
}
export function downloadLista() {
    try {
        return axios({
            url: `${process.env.VUE_APP_ROOT_API}/Equipamento/downloadEquipamentos`,
            method: 'GET',
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        }).catch(() => {
            return { status: false };
        })
            .then((response) => {
                if (response.status === false)
                    return response;
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'equipamentos' + '.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();
            });
    } catch (e) {
        throw e;
    }
}
